import { memo } from 'react';

import styles from './styles.module.scss';

export const LoadingBlock = memo(function LoadingBlock() {
  return <div className={styles.container} />;
});
